export default "__VITE_PUBLIC_ASSET__0ba83e98__"